import styled from 'styled-components';
import { KIOSK_PRO_MEDIA } from '../../kiosk-pro-shared/kiosk-pro-shared.styles';

export const PhoneNumberLoginSuccessContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 72px;
  gap: 72px;
  width: 100%;
  text-align: center;

  h3 {
    font-weight: 500;
    font-size: 72px;
    margin-bottom: 72px;
    line-height: 1.25;
  }

  /* Primary button (countdown animation) — show first */
  [data-testid='idle-warning-new-session'] {
    order: 1;
  }

  /* Secondary button — show second */
  [data-testid='idle-warning-continue-shopping'] {
    order: 2;
  }

  /* Button overrides for full-screen context */
  button {
    border-radius: 800px;
    height: 108px;
    width: 396px;
    max-width: 100%;
    font-size: 36px;
    font-weight: 700;
    padding: 36px 56px;
    line-height: 1;
  }

  /* Space between buttons — secondary shows second via order */
  [data-testid='idle-warning-continue-shopping'] {
    margin-top: 36px;
  }

  @media ${KIOSK_PRO_MEDIA.landscapeMaxWidth}, ${KIOSK_PRO_MEDIA.portraitMaxWidth} {
    padding: 56px;
    gap: 56px;

    h3 {
      font-size: 56px;
      margin-bottom: 56px;
    }

    button {
      font-size: 28px;
      padding: 28px 48px;
      width: 320px;
      height: 84px;
    }

    [data-testid='idle-warning-continue-shopping'] {
      margin-top: 28px;
    }
  }

  @media ${KIOSK_PRO_MEDIA.smallViewportPortrait}, ${KIOSK_PRO_MEDIA.smallViewportLandscapeOnly} {
    padding: 48px;
    gap: 48px;

    h3 {
      font-size: 48px;
      margin-bottom: 48px;
    }

    button {
      font-size: 24px;
      padding: 16px 40px;
      width: 280px;
      height: 72px;
    }

    [data-testid='idle-warning-continue-shopping'] {
      margin-top: 24px;
    }
  }
`;

export const SuccessIconContainer = styled.div`
  @media ${KIOSK_PRO_MEDIA.landscapeMaxWidth}, ${KIOSK_PRO_MEDIA.portraitMaxWidth} {
    svg {
      width: 156px;
      height: 156px;
    }
  }

  @media ${KIOSK_PRO_MEDIA.smallViewportPortrait} {
    svg {
      width: 112px;
      height: 112px;
    }
  }

  @media ${KIOSK_PRO_MEDIA.smallViewportLandscape} {
    svg {
      width: 120px;
      height: 120px;
    }
  }
`;
